module.exports = __webpack_public_path__ + "static/media/proxxmu-infoarch.0bbd182d.png";